export default __webpack_public_path__ + "static/media/desktop-build-image.40358c58.jpg";